import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=503d52da&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=503d52da&lang=scss&scoped=true&"
import style1 from "./Video.vue?vue&type=style&index=1&id=503d52da&scoped=true&lang=css&"
import style2 from "./Video.vue?vue&type=style&index=2&id=503d52da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d52da",
  null
  
)

export default component.exports